module.exports = __webpack_public_path__ + "img/img09.6c2f40f4.png";